import styled, { css } from 'styled-components'
import {
  mediaDesktopAndUp,
  mediaExtraLargeScreens,
  mediaTabletAndDown,
} from 'uiComponents/constants/customMedia'
import { StoryTileSelector } from '../StoryTile/StoryTile'

// Width is calculated by "total margin between the tiles" / "number of tiles in the row"
// Simulates a grid-gap (which isn't supported by IE11)
export const HighlightTileRowContainer = styled.div<{
  highlighted?: boolean
  reverseHighlight?: boolean
}>`
  display: flex;
  padding-bottom: 10px;
  flex-wrap: wrap;

  ${({ highlighted, reverseHighlight }) =>
    highlighted
      ? css`
          @media ${mediaDesktopAndUp} {
            flex-direction: column;
            flex-wrap: ${reverseHighlight ? 'wrap' : 'wrap-reverse'};
          }
        `
      : css`
          @media ${mediaDesktopAndUp} {
            flex-wrap: nowrap;
          }
        `}

  & > ${StoryTileSelector} {
    margin: 0 5px;

    @media ${mediaTabletAndDown} {
      &:nth-child(odd) {
        margin-left: 0;
      }
      &:nth-child(even) {
        margin-right: 0;
      }
    }

    width: calc(50% - 5px);

    ${({ highlighted }) =>
      !highlighted &&
      css`
        &:first-child {
          margin-left: 0;
        }
        &:last-child {
          margin-right: 0;
        }

        @media ${mediaDesktopAndUp} {
          width: calc(33.3% - 5px);
        }
      `}

    ${({ highlighted, reverseHighlight }) =>
      highlighted &&
      css`
        @media ${mediaDesktopAndUp} {
          flex-grow: 1;
          flex-basis: 300px;
          width: calc(33.3% - 7px);
          margin-right: ${reverseHighlight ? '5px' : 0};
          margin-left: ${reverseHighlight ? 0 : '5px'};

          &:nth-child(1) {
            margin-bottom: 5px;
          }

          &:nth-child(2) {
            margin-top: 5px;
          }

          &:nth-child(3) {
            width: calc(66.6% - 2px);
            margin-right: ${reverseHighlight ? 0 : '5px'};
            margin-left: ${reverseHighlight ? '5px' : 0};
          }
        }

        @media ${mediaExtraLargeScreens} {
          flex-basis: 400px;
        }
      `}
  }
`
